import {
  Button,
} from '@material-ui/core/';
import React, {
  Component,
} from 'react';
import {
  ExtendedSnackbar,
} from '../..';

interface Props {
  snackbarRef: React.RefObject<ExtendedSnackbar>;
}
class SnackBarComponent extends Component<Props> {
  static instance: SnackBarComponent;

  static getInstance() {
    return SnackBarComponent.instance;
  } 

  constructor(props: Props) {
    super(props);
    if (SnackBarComponent.instance) {
      throw new Error('Please check your code there exists more than one instance of SnackBarComponent');
    }
    SnackBarComponent.instance = this;
  }

  componentWillUnmount(): void {
    delete SnackBarComponent.instance;
  }

  openSnackbar = (message: string, duration: number, status: 'success' | 'warning' | 'error' | 'info') => {
    console.warn(this.props.snackbarRef.current);
    (this.props.snackbarRef.current! as any).enqueueSnackbar(message, {
      autoHideDuration: duration,
      variant: status,
      action: (
        <Button
          color="default"
        >
          Dismiss
        </Button>
      ),
      anchorOrigin: {
        vertical: 'bottom',
        horizontal: 'right',
      },
    });
  };

  render() {
    return null;
  }
}

export default SnackBarComponent;
